
import React from 'react';

const EmptyErrorState: React.FC = () => {
  return (
    <div className="border rounded-lg p-8 text-center">
      <p className="text-muted-foreground">No errors have been logged</p>
    </div>
  );
};

export default EmptyErrorState;
